module.exports = __webpack_public_path__ + "static/img/gc_monetary.a345465.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_monetary.png
// module id = 305
// module chunks = 1